// extracted by mini-css-extract-plugin
module.exports = {"base":"fourteenStories2AdBigFact-m__base__1-gpY","ad-slot":"fourteenStories2AdBigFact-m__ad-slot__2TNMg","wrapper":"fourteenStories2AdBigFact-m__wrapper__1cHgB"};